// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3f0kf","requiredAsterisk":"Info_requiredAsterisk__3lK3v"};